var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenFloating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3763_137000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 32,
    fill: "#3DCF94"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 20C29.134 20 26 23.134 26 27C26 30.866 29.134 34 33 34L47 34C50.866 34 54 30.866 54 27C54 23.134 50.866 20 47 20L33 20ZM47 32C49.7614 32 52 29.7614 52 27C52 24.2386 49.7614 22 47 22C44.2386 22 42 24.2386 42 27C42 29.7614 44.2386 32 47 32Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7416 48.582H33.4876V50.052H21.7416V48.582ZM26.7676 49.548H28.6576V52.278H26.7676V49.548ZM23.1136 53.524H32.1996V55.022H23.1136V53.524ZM23.1136 51.144H24.9896V53.902H23.1136V51.144ZM27.6076 42.52C30.3936 42.52 32.2696 43.57 32.2696 45.208C32.2696 46.86 30.3936 47.896 27.6076 47.896C24.8076 47.896 22.9456 46.86 22.9456 45.208C22.9456 43.57 24.8076 42.52 27.6076 42.52ZM27.6076 43.99C25.9696 43.99 24.9476 44.41 24.9476 45.208C24.9476 46.006 25.9696 46.412 27.6076 46.412C29.2456 46.412 30.2676 46.006 30.2676 45.208C30.2676 44.41 29.2456 43.99 27.6076 43.99ZM40.3605 43.976H44.1965V45.46H40.3605V43.976ZM40.3605 46.846H44.1965V48.344H40.3605V46.846ZM38.2045 42.968C40.1365 42.968 41.6205 44.312 41.6205 46.146C41.6205 47.98 40.1365 49.324 38.2045 49.324C36.2585 49.324 34.7745 47.98 34.7745 46.146C34.7745 44.312 36.2585 42.968 38.2045 42.968ZM38.2045 44.55C37.2525 44.55 36.5525 45.124 36.5525 46.146C36.5525 47.154 37.2525 47.756 38.2045 47.756C39.1565 47.756 39.8565 47.154 39.8565 46.146C39.8565 45.124 39.1565 44.55 38.2045 44.55ZM43.6085 42.282H45.4705V49.87H43.6085V42.282ZM41.0745 50.136C43.8045 50.136 45.5125 51.088 45.5125 52.698C45.5125 54.308 43.8045 55.246 41.0745 55.246C38.3445 55.246 36.6365 54.308 36.6365 52.698C36.6365 51.088 38.3445 50.136 41.0745 50.136ZM41.0745 51.578C39.3805 51.578 38.4705 51.942 38.4705 52.698C38.4705 53.454 39.3805 53.818 41.0745 53.818C42.7825 53.818 43.6785 53.454 43.6785 52.698C43.6785 51.942 42.7825 51.578 41.0745 51.578ZM52.4275 48.792H54.2895V51.074H52.4275V48.792ZM47.4995 48.176H59.2175V49.646H47.4995V48.176ZM53.3375 50.57C56.1375 50.57 57.8315 51.41 57.8315 52.908C57.8315 54.406 56.1375 55.246 53.3375 55.246C50.5235 55.246 48.8295 54.406 48.8295 52.908C48.8295 51.41 50.5235 50.57 53.3375 50.57ZM53.3375 51.97C51.6015 51.97 50.7195 52.264 50.7195 52.908C50.7195 53.538 51.6015 53.846 53.3375 53.846C55.0735 53.846 55.9555 53.538 55.9555 52.908C55.9555 52.264 55.0735 51.97 53.3375 51.97ZM52.0775 43.5H53.7295V43.822C53.7295 45.768 51.9795 47.364 48.6335 47.672L47.9895 46.216C50.8315 45.978 52.0775 44.83 52.0775 43.822V43.5ZM52.9875 43.5H54.6395V43.822C54.6395 44.844 55.8715 45.978 58.7275 46.216L58.0835 47.672C54.7515 47.364 52.9875 45.782 52.9875 43.822V43.5ZM48.5635 42.814H58.1675V44.284H48.5635V42.814Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3763_137000",
    x: 3,
    y: 5,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3763_137000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3763_137000",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenFloating);
export default __webpack_public_path__ + "static/media/open-floating.2a539f01b52589eb13685002279e3df0.svg";
export { ForwardRef as ReactComponent };